module.exports = __webpack_public_path__ + "static/media/pit.1211d254.jpeg";